import * as n from "fp-ts/lib/Either";
import * as e from "fp-ts/lib/Option";
function r(o) {
  return o.cata(
    (t) => n.left(t),
    (t) => n.right(t)
  );
}
function a(o) {
  return o.isSome() ? e.of(o.some()) : e.none;
}
function c(o) {
  return o.cata(
    (t) => e.none,
    (t) => e.some(t)
  );
}
export {
  a,
  c as b,
  r as c
};
//# sourceMappingURL=convertMonet-gKQ8jnih.mjs.map
